
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_32266","data-name":"Group 32266","xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"Rectangle_9388","data-name":"Rectangle 9388","width":"14","height":"14","fill":"none"}}),_c('g',{attrs:{"id":"Group_32263","data-name":"Group 32263"}},[_c('g',{attrs:{"id":"Group_32265","data-name":"Group 32265","fill":"none","stroke":"#97A0AE","stroke-linecap":"round","stroke-width":"1.2"}},[_c('line',{attrs:{"id":"Line_914","data-name":"Line 914","x1":"9.043","y2":"9.043","transform":"translate(2.203 2.561)","stroke-miterlimit":"10"}}),_c('path',{attrs:{"id":"Path_21133","data-name":"Path 21133","d":"M6.261 2.761L3.354 5.668 2.2 4.449","stroke-linejoin":"round"}}),_c('line',{attrs:{"id":"Line_915","data-name":"Line 915","x1":"3.516","y2":"3.516","transform":"translate(8.284 8.634)","stroke-linejoin":"round"}}),_c('line',{attrs:{"id":"Line_916","data-name":"Line 916","x2":"3.516","y2":"3.516","transform":"translate(8.284 8.634)","stroke-linejoin":"round"}})])])])
          )
        }
      }
    